import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

export const splitActionButtonStyles = {
  button: {
    mr: "1px",
    height: 36,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  dropdownButton: {
    px: 0,
    height: 36,
    minWidth: 40,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
};

export default function SplitActionButton({ children, renderMenuItems }) {
  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      {children}

      <Box variant="contained" aria-label="split button">
        <PopupState variant="popover" popupId="demo-popup-menu">
          {popupState => (
            <React.Fragment>
              <Button
                variant="contained"
                color="primary"
                {...bindTrigger(popupState)}
                sx={splitActionButtonStyles.dropdownButton}
              >
                <KeyboardArrowDownIcon
                  sx={{ transform: popupState.open ? undefined : "rotate(180deg)" }}
                />
              </Button>
              <Menu {...bindMenu(popupState)}>{renderMenuItems(popupState)}</Menu>
            </React.Fragment>
          )}
        </PopupState>
      </Box>
    </Box>
  );
}
